import RangePicker from '@home/components/RangePicker';
import { DBO_TM } from '@op/utils/format';
import moment, { Moment } from 'moment';
import React, { useMemo } from 'react';
import {
  moreKeyCommonMapStateToProps,
  moreKeyCommonMapDispatchToProps,
} from '../../connect/moreKeyCommon';
import { connect } from 'umi';
import {
  IDateAllCommonSelectType,
  IDateConfig,
  ISingleDateCommonType,
  TDateShortcutType,
} from '../../types';
import useIntls from '@opm/hooks/useIntls';

interface ShortcutOptionType {
  date?: TDateShortcutType[];
}

// 默认快捷选项配置
const defaultShortcutOptions: TDateShortcutType[] = [
  {
    name: 'All',
    nameCN: '全部',
    type: 'all',
    timeType: 'date',
    onClick: () => [] as any,
  },
  {
    name: 'Today',
    nameCN: '今天',
    type: 'today',
    timeType: 'date',
    onClick: () => [moment(), moment()],
  },
  {
    name: 'Last 7 Days',
    nameCN: '近7天',
    type: 'last7Days',
    timeType: 'date',
    onClick: () => [moment().subtract(6, 'day'), moment()],
  },
  {
    name: 'Last 30 Days',
    nameCN: '近30天',
    type: 'last30Days',
    timeType: 'date',
    onClick: () => [moment().subtract(29, 'day'), moment()],
  },
  {
    name: 'Last 180 Days',
    nameCN: '近180天',
    type: 'last180Days',
    timeType: 'date',
    onClick: () => [moment().subtract(179, 'day'), moment()],
  },
  {
    name: 'Last 1 Year',
    nameCN: '近1年',
    type: 'last1Year',
    timeType: 'date',
    onClick: () => [moment().subtract(364, 'day'), moment()],
  },
];

export type TMultiDateAllSelect = IDateAllCommonSelectType & IDateConfig;

function MultiDateAllSelect({
  filterValue,
  valueKeys,
  change,
  optionsMap = { date: { value: 'date', text: 'Day', text_cn: '日' } },
  defaultValue = { date: [DBO_TM.utc(), DBO_TM.utc()] },
  type = 'date',
  typeList = ['date'],
  startOfTime = '2001-01-01',
  disabledDate,
  shortcutOptions,
}: TMultiDateAllSelect & ISingleDateCommonType) {
  const { isEn } = useIntls();
  const rangePickerValue = useMemo(() => {
    const { start_time, end_time } = valueKeys;
    return [start_time, end_time].map((key) =>
      filterValue[key] ? moment(filterValue[key]) : undefined,
    );
  }, [filterValue]);

  // 获取时间的开始和结束时间 如果改变日期，这里value会返回[null, null]
  const onChangeRangePicker = (value: [Moment, Moment]) => {
    const [start_time, end_time] = value;
    const { startTime, endTime } = {
      startTime: start_time
        ?.startOf('day')
        ?.startOf('hour')
        ?.format('YYYY-MM-DD HH:mm:ss'),
      endTime: end_time
        ?.endOf('day')
        ?.endOf('hour')
        ?.format('YYYY-MM-DD HH:mm:ss'),
    }; 
    change({
      [valueKeys.start_time]: startTime,
      [valueKeys.end_time]: endTime,
    });
  };

  // 使用传入的快捷选项或默认选项
  const customShortcutOption: ShortcutOptionType = {
    date: shortcutOptions || defaultShortcutOptions,
  };

  return (
    <div className="dbom-marketing-date-all-select-wrapper date-select-wrapper search-item search-item-date date-select-wrapper-hour">
      <RangePicker
        autoStartDay={false}
        onChange={onChangeRangePicker}
        typeList={typeList}
        type={type}
        startOfTime={startOfTime}
        defaultValue={defaultValue}
        optionsMap={optionsMap}
        showSelectType={typeList.length > 1}
        value={rangePickerValue}
        language={isEn ? 'en' : 'cn'}
        setShortcutOption={() => customShortcutOption}
        disabledDate={disabledDate}
      />
    </div>
  );
}

export default connect(
  moreKeyCommonMapStateToProps,
  moreKeyCommonMapDispatchToProps,
)(MultiDateAllSelect);
